const stripeErrorMessages = {
  "authentication_required": "Your card requires authentication. Please complete the verification process.",
  "approve_with_id": "This transaction requires additional approval. Please contact your bank.",
  "call_issuer": "Your card issuer requires verification before processing this payment.",
  "card_not_supported": "This card type is not supported for this transaction.",
  "card_velocity_exceeded": "Too many transactions have been made with this card recently. Try again later.",
  "currency_not_supported": "Your card does not support this currency. Please use another payment method.",
  "do_not_honor": "Your bank has declined this transaction. Please verify your payment details, use another payment method or contact your bank.",
  "do_not_try_again": "This transaction has been declined. Please use another payment method.",
  "duplicate_transaction": "It looks like you've already made this transaction. Please check your payment history.",
  "expired_card": "Your card has expired. Please use another card.",
  "fraudulent": "This transaction has been flagged as fraudulent. Contact your bank for more details.",
  "generic_decline": "Your payment was declined. Please try another payment method or contact your bank.",
  "incorrect_cvc": "The security code (CVC) you entered is incorrect.",
  "incorrect_number": "The card number you entered is incorrect.",
  "insufficient_funds": "Your card has insufficient funds. Please use another payment method.",
  "invalid_card": "The card you entered is invalid. Please check the details and try again.",
  "invalid_expiry_month": "The expiration month entered is invalid.",
  "invalid_expiry_year": "The expiration year entered is invalid.",
  "invalid_pin": "The PIN entered is incorrect.",
  "issuer_not_available": "Your card issuer is currently unavailable. Try again later or use another payment method.",
  "lost_card": "This card has been reported as lost. Please use another payment method.",
  "new_account_information_available": "Your card details have changed. Please update your payment method.",
  "no_action_taken": "Your payment was declined. No further details were provided.",
  "not_permitted": "This transaction is not permitted. Please contact your bank.",
  "pickup_card": "This card has been reported lost or stolen. Contact your bank for further details.",
  "processing_error": "A processing error occurred. Please try again later.",
  "reenter_transaction": "There was an issue processing your payment. Please try again.",
  "restricted_card": "This card cannot be used for this transaction. Please use another payment method.",
  "revocation_of_all_authorizations": "Your card issuer has revoked all transactions. Contact your bank.",
  "security_violation": "This transaction violates security rules. Contact your bank.",
  "service_not_allowed": "This service is not allowed for this card. Please use another payment method.",
  "stolen_card": "This card has been reported stolen. Contact your bank.",
  "stop_payment_order": "A stop payment order was issued. Contact your bank.",
  "transaction_not_allowed": "Your bank has declined this transaction. Please contact them for details.",
  "try_again_later": "Your payment could not be processed at this time. Please try again later.",
  "withdrawal_count_limit_exceeded": "Your card has reached its withdrawal limit. Try another payment method.",
};

/**
 * Function to get a friendly error message from a Stripe decline code
 * @param {string} code - Stripe decline code
 * @returns {string} - Friendly error message
 */
const getStripeErrorMessage = (code) => {
  return stripeErrorMessages[code] || "An error occurred while processing your transaction. Please try again.";
};

export default getStripeErrorMessage;